import {PlaceholderTiles} from '@aboutyou/ui-components';
import {useWishlistCount} from '@aboutyou/user';
import React from 'react';
import {WishlistItemGrid} from '../WishlistItemGrid/WishlistItemGrid';

export const WishlistItemStreamLoading: React.FC<{className?: string}> = ({
  className,
}) => {
  const {count} = useWishlistCount();

  // Should avoid rendering the footer before the product stream
  return (
    <WishlistItemGrid className={className}>
      <PlaceholderTiles amount={count < 24 ? 24 : count} ctaVisible Comp="li" />
    </WishlistItemGrid>
  );
};
